import { render, staticRenderFns } from "./ProvinceEffective.vue?vue&type=template&id=07409e04"
import script from "./ProvinceEffective.vue?vue&type=script&lang=js"
export * from "./ProvinceEffective.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports